import type { JSX } from "react";

import Markdown from "markdown-to-jsx";
import { Fragment } from "react";

import { expandRichPhrase } from "./expandRichPhrase";
import classes from "./RichPhrase.module.css";

export interface RichPhraseProps {
    markdown: string;
}

/**
 * Deliberately NOT built on @expert/solve-tools' MarkdownViewer, though it wraps the same library.
 * MarkdownViewer unconditionally spreads hyperMediaOverride, mapping `a` to OzmoLink and `img` to
 * ImageZoomPan — Ozmo guide components that have no place in a sales script. markdown-to-jsx is
 * therefore a direct dependency rather than one reached through solve-tools: relying on a transitive
 * dep is a phantom dependency, the pattern behind the duplicate-@mantine/core resolution this repo
 * has already been bitten by.
 *
 * Renders Markdown copy authored in Contentful — nested example lists, plus the `==...==` token that
 * highlights the words an expert must say verbatim. The highlight itself is styled by the global
 * `mark.verbatim` rule in @expert/theme/global.css, so nothing the CMS writes can influence it.
 */
export function RichPhrase({ markdown }: RichPhraseProps): JSX.Element {
    return (
        <div className={classes.richPhrase}>
            <Markdown options={{ forceBlock: true, wrapper: Fragment }}>{expandRichPhrase(markdown)}</Markdown>
        </div>
    );
}
